<script>
export default {
  name: "loginFooter",
  computed: {
    year(){
      return new Date().getFullYear();
    }
  }
};
</script>

<template>
  <footer>© Copyright {{year}}. CMS On Test. All Rights Reserved.</footer>
</template>

<style scoped lang="scss">
footer {
  font-size: 0.69rem;
  height: 15px;
  background-color: $white-two-color;
  display:flex;
  justify-content: center;
}
</style>
